exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2632Hyaqon345SsmEi0lXB{display:inline;width:70%}html[dir=ltr] ._2632Hyaqon345SsmEi0lXB{float:left}html[dir=rtl] ._2632Hyaqon345SsmEi0lXB{float:right}._2XaEBKfJ0bNydr7YYGRiX9{font-size:14px;line-height:19px;font-weight:400}._3AZcbZ2fE8XRJgml_lUgDM{display:inline}html[dir=ltr] ._3AZcbZ2fE8XRJgml_lUgDM{float:right}html[dir=rtl] ._3AZcbZ2fE8XRJgml_lUgDM{float:left}", ""]);

// exports
exports.locals = {
	"subscription_text_container": "_2632Hyaqon345SsmEi0lXB",
	"premiumDashboard_text_content": "_2XaEBKfJ0bNydr7YYGRiX9",
	"subscription_btn_container": "_3AZcbZ2fE8XRJgml_lUgDM"
};